<div class="rfq-multi-hedge-item">
  <div class="icons"></div>
  <form [formGroup]="form" class="form" autocomplete="off">
    <div class="product-type">
      <input-with-spinner
        formControlName="productType"
        [className]="'productType'"
        [readOnly]="true"
      ></input-with-spinner>
    </div>
    <div class="notional">
      <input-with-spinner
        formControlName="notional"
        (inputChange)="changeInText('notional', $event)"
        (onBlur)="!volBased && onElemBlur('notional')"
        (onFocus)="!volBased && onElemFocus()"
        [className]="'notional'"
        [inputValidator]="['numericShorthand', 'positiveNumber']"
        [readOnly]="volBased"
        [textColor]="inputsColors['notional']"
      ></input-with-spinner>
      <span class="ccy"> {{ cross | slice: 0 : 3 }}</span>
    </div>
    <div class="position">
      <input-with-spinner
        formControlName="position"
        [className]="'position'"
        [readOnly]="true"
      ></input-with-spinner>
    </div>
    <div class="bidPosition">
      <input-with-spinner
        formControlName="bidPosition"
        [className]="'bidPosition'"
        [readOnly]="true"
      ></input-with-spinner>
    </div>
    <div class="strike">
      <input-with-spinner
        formControlName="strike"
        (inputChange)="changeInText('strike', $event)"
        (onBlur)="!(volBased || isCustomHedge) && onElemBlur('strike')"
        (onFocus)="!(volBased || isCustomHedge) && onElemFocus()"
        [className]="'strike'"
        [type]="'number'"
        [textColor]="inputsColors['strike']"
        [readOnly]="volBased || isCustomHedge"
      ></input-with-spinner>
    </div>
    <div class="settlementDate">
      <date-with-spinner-info
        formControlName="settlementDate"
        (inputChange)="changeInText('settlementDate', $event)"
        (onBlur)="!volBased && onElemBlur('settlementDate')"
        (onFocus)="!volBased && onElemFocus()"
        (onCalendarChange)="settlementDateCalendarChange()"
        class="settlement-date"
        [textColor]="inputsColors['settlementDate']"
        [format]="'D MMM YYYY'"
        [required]="true"
        [readOnly]="isSpot"
        [inputValidator]="['prettyDate']"
      >
      </date-with-spinner-info>
    </div>
    <div class="expiryDate" *ngIf="showExpiryDate">
      <date-with-spinner-info
        formControlName="expiryDate"
        (inputChange)="changeInText('expiryDate', $event)"
        (onBlur)="onElemBlur('expiryDate')"
        (onFocus)="onElemFocus()"
        class="expiry-date"
        [format]="'D MMM YYYY'"
        [required]="true"
        [inputValidator]="['prettyDate']"
      >
      </date-with-spinner-info>
    </div>
    <div *ngIf="hedgeMode === 'DX'" class="impliedSpot">
      <input-with-spinner
        formControlName="impliedSpot"
        [className]="'impliedSpot'"
        [readOnly]="true"
      ></input-with-spinner>
    </div>
  </form>
</div>
